<template>
  <PButton
    v-bind="$attrs"
    icon-pos="right"
    class="button-token p-button-rounded"
    :class="{ 'is-selected': !!token, 'button-token-small': isSmall }"
  >
    <template v-if="token">
      <TokenIcon
        :logo="token?.logo"
        :type="token?.type"
        class="img mr-2"
        size="24"
      />
      <div class="token-title">
        <div class="mr-1 token-name">
          {{ token?.symbol }}<token-alert :type="token?.type" />
        </div>
        <div class="mr-1 token-provider">
          {{ tokenProvider }}
        </div>
      </div>
    </template>
    <template v-else>
      <span class="mr-1">{{ $t('pools.selectToken') }}</span>
    </template>
    <slot v-if="!isSmall" name="prepend">
      <i class="pi pi-angle-down ml-auto" />
    </slot>
  </PButton>
</template>

<script lang="ts" setup>
import { TokenAlert } from '@/components/UI/TokenAlert';
import { TokenIcon } from '@/components/UI/TokenIcon';
import { computed } from 'vue';
import { IPersistedTokenExtended } from '@/store';
import { providerForToken } from '@/utils/tokens';

interface IProps {
  /**
   * Token entity
   */
  tokenEntity?: IPersistedTokenExtended;

  isSmall?: boolean;
}

defineEmits(['close']);
const props = defineProps<IProps>();

const token = computed(() => {
  if (!props?.tokenEntity) {
    return;
  }

  return props.tokenEntity;
});

const isSmall = computed(() => {
  return props.isSmall ?? false;
});

const tokenProvider = computed(() => {
  if (token?.value?.type.length && token?.value?.type.length > 0) {
    return providerForToken(token.value);
  }
  return '';
});
</script>

<style lang="scss" scoped>
.button-token-small {
  min-width: 110px !important;
  cursor: default;
}

.button-token {
  min-width: 140px;
  font-size: 15px;
  height: 3rem;
  padding: 0 12px;
  box-shadow: rgb(0 0 0 / 8%) 0 6px 10px;
  background: linear-gradient(90deg, #016875 0%, #04b78a 100%);
  border: none;
  border-radius: 12px;
  color: white;

  &:hover {
    background: linear-gradient(90deg, #015c68 0%, #04a57d 100%);
    color: white;
  }

  span {
    white-space: nowrap;
    font-weight: normal !important;
  }

  img {
    width: 24px;
    height: 24px;
  }

  &.is-selected {
    color: var(--surface-0) !important;
    background: #1c1c33 !important;
    border-color: transparent !important;

    &:hover {
      background: #16162a !important;
    }
  }
}

.token-title {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  margin-right: auto;

  .token-name {
    font-size: 15px;
  }

  > .token-provider {
    color: #9594aa;
    font-weight: 500;
    font-size: 11px;
    line-height: 12px;
  }
}
</style>
